import { PhoneIcon } from "lucide-react";

import { Row, Text } from "@/components";
import { TableCell, TableRow } from "@/components/ui/table";

// Divides the Applied stage: candidacies below it were routed to Stevie and are
// waiting on the call, so they need no decision yet.
export const AwaitingStevieSectionRow = ({
  colSpan,
  count,
}: {
  colSpan: number;
  count: number;
}) => (
  <TableRow className="hover:bg-transparent">
    <TableCell
      colSpan={colSpan}
      className="border-b border-slate-200 bg-slate-50/60 py-2"
    >
      <Row className="items-center gap-1.5">
        <PhoneIcon className="h-3.5 w-3.5 text-slate-500" />
        <Text className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
          Sent to Stevie{" "}
          <span className="font-normal tabular-nums">({count})</span>
        </Text>
      </Row>
    </TableCell>
  </TableRow>
);
